/**
 * Shared formatting for Discord / support “paste this” blocks (MoneyMotion, PayPal F&F, crypto).
 */

export function orderItemsToPasteSummary(
  items: ReadonlyArray<{ name: string; quantity: number }>,
): string {
  if (!items.length) return ''
  return items.map((i) => (i.quantity === 1 ? i.name : `${i.quantity}× ${i.name}`)).join('\n')
}

/**
 * @param purchaseSummaryLines — newline-separated lines (`qty× name` when qty > 1), or a single product name.
 * @returns block to append after session/order/email lines (leading newline when non-empty).
 */
export function supportPasteProductSection(purchaseSummaryLines: string): string {
  const raw = purchaseSummaryLines.trim()
  if (!raw) return ''
  if (raw.includes('\n')) {
    const lines = raw
      .split('\n')
      .map((l) => l.trim())
      .filter(Boolean)
      .map((l) => `- ${l}`)
    return lines.length ? `\nProducts purchased:\n${lines.join('\n')}` : ''
  }
  return `\nProduct: ${raw}`
}
